<div class="search" style="justify-content: space-between;">
    <div class="search-input-icon">
        <div class="search-input"><i class="flaticon-search"></i></div>
        <input type='text' [placeholder]='"Search ticket orders..."' (keyup)='reloadTable()' [(ngModel)]="searchText" class="searchtext"/>
    </div>
    <div>
        <label id="event" style="padding: 0 15px 0 0; vertical-align: middle; text-align: center;">Filter by Event</label>
        <select
            style="width: 200px; color: black; height: 37px; margin-left: 5px; display: inline;"
            id="organization"
            class="form-control m-input"
            (change)="reloadTable()" 
            [(ngModel)]="selectedEvent"
            name="organization">
        <option 												      
            [ngValue]="0">
            -- Reset Selection --
        </option>
        <option *ngFor="let event of events" 													      
            [ngValue]="event">
            {{event.event.name}}
        </option>
        
        </select>
    </div>
    <div>
        <label id="itemsPerPage" style="padding: 0 15px 0 0; vertical-align: middle; text-align: center;">Items per page</label>
        <select
            style="width: 75px; color: black; height: 37px; margin-left: 5px; display: inline;"
            class="form-control m-input"
            (change)="reloadTable();" 
            [(ngModel)]="page.limit"
            id="itemsPerPage"
            >
            <option value=25>25</option>
            <option value=50>50</option>
            <option value=75>75</option>
            <option value=100>100</option>
        </select>
    </div>
</div>

<br>

<ngx-spinner
    bdColor="rgba(75, 55, 100, 0.5)"
    size="large"
    color="#fff"
    type="line-scale-pulse-out">
        <span class="chevron left"></span>
        <span class="chevron right"></span>
  </ngx-spinner>

<ngx-datatable 
    #packageTable 
    class='material striped datatable' 
    [rows]='ticketOrders' 
    [columnMode]='"force"'
    [headerHeight]='40' 
    [footerHeight]="20"
    [virtualization]="false"
    [scrollbarV]="true"
    [scrollbarH]="true"
    [rowHeight]="40"
    [reorderable]="true"
    [offset]="page.offset"
    [count]="page.count"
    [externalPaging]="true"
    [externalSorting]="false"
    (page)="pageCallback($event)"
    (sort)="sortCallback($event)">


    <ngx-datatable-column prop="customerName" [sortable]="true" width="200">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()">
                Customer Name
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.customerName }}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="eventName" [sortable]="true" width="200">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()">
                Event Name
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.eventName }}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="referenceNumber" [sortable]="true" width="200">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()">
                Reference Number
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.referenceNumber }}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="operatorName" [sortable]="true">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()">
                Operator Name
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.operatorName }}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="stationName" [sortable]="true">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()">
                POS Station Name
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
            {{row.stationName}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="ticketsPurchased" [sortable]="true">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()">
                Number of tickets
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.ticketsPurchased }}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="totalAmount" [sortable]="true">
        <ng-template let-column="totalAmount" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()">
                Total Amount
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.totalAmount/100 | currency }}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="netAmount" [sortable]="true">
        <ng-template let-column="netAmount" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()">
                Net Amount
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.netAmount/100 | currency }}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="datePurchased" [sortable]="true" width="200">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()">
                Date Purchased
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.datePurchased | date:'M/d/yyyy hh:mm a' }}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="lastReprintDate" [sortable]="true" width="200">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()">
                Last Reprint Date
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.lastReprintDate | date:'M/d/yyyy hh:mm a' }}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="adminFee" [sortable]="true">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()">
                Admin Fee
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.adminFee/100 | currency }}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="expenseFee" [sortable]="true">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()">
                Expense Fee
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.expensesFee/100 | currency }}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="stripeFee" [sortable]="true">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()">
                Stripe Fee
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.stripeFee/100 | currency }}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="paymentMethodTypes" [sortable]="true">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()">
                Payment Method
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
            {{ convertPaymentTypeString(row.paymentMethodTypes) }}
        </ng-template>
    </ngx-datatable-column>


    <ngx-datatable-column prop="status" [sortable]="true">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span>
                Status
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
            <div *ngIf="!row.refunded && row.status === 1" class="block-icon status blu"><span>SCHEDULED</span></div>
            <div *ngIf="!row.refunded && row.status === 4"  class="block-icon status red"><span>ERROR</span></div>
            <div *ngIf="!row.refunded && row.status === 2"  class="block-icon status blu-grn"><span>IN PROGRESS</span></div>
            <div *ngIf="!row.refunded && row.status === 3"  class="block-icon status grn"><span>COMPLETED</span></div>
            <div *ngIf="!row.refunded && row.status === 6"  class="block-icon status grn"><span>TRANSFERRED</span></div>
            <div *ngIf="row.refunded"  class="block-icon status red"><span>REFUNDED</span></div>
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column width="250">
        <ng-template let-row="row" ngx-datatable-cell-template>
            <button 
                *ngIf="!row.refunded && (row.status === 3 || row.status === 6) && (row.paymentMethodTypes === 'card' || row.paymentMethodTypes === 'card_present')" 
                (click)="refundOrder(row)">
                    Refund
            </button>
            <button 
                *ngIf="!row.refunded && (row.status === 3 || row.status === 6)" 
                (click)="resendReceipt(row)">
                    Resend Receipt
            </button>
        </ng-template>
    </ngx-datatable-column>

</ngx-datatable>